export default __webpack_public_path__ + "static/media/HFI-HT.eefd9fe3.png";